import { enhanceEvalString } from "../../../Molecules/Common/Renderers/Views/ResultCards/M_ResultCardHelper";
import { httpPost } from "../../../../../Utils/apis/apis";
import {
  hasAccess,
  pageSecurityActions,
} from "../../../../../Utils/Helpers/pageSecurity";
export const contentTypes = {
  PORTFOLIOAPPROVAL: "portfolioapproval",
  CRMDATA: "crmdata",
  SQLVIEW: "sqlview",
  CHART: "chart",
  MAPS: "maps",
  NEWS: "news",
  RESULT_TEMPLATE: "resultTemplate",
  DOCUMENTS: "documents",
  PORTFOLIO_FILE_UPLOAD: "portfolioFileUpload",
  PREVIOUS_TEMPLATE: "previousTemplate",
  PREVIOUS_UPLOADS: "previousUploads",
  CHART_ENTRY: "chartEntry",
  TIMELINE: "timeline",
  GUIDELINES: "guidelines",
  MAPGOOGLE: "mapgoogle",
  IRC_DETAIL: "ircDetail",
  DEAL_ADMINISTRATION: "dealAdministration",
  BOOKING_SLOT: "bookingSlot",
  IC_VIEW: "icView",
  GENERIC_RESULT_TEMPLATE: "genericResultTemplate",
  CHECKLIST_MASTER: "checklistMaster",
  ACTIVE_FACILITY: "activeFacility",
  LENDERS_APPROACHED: "lendersApproached",
  MANAGED_BY: "managedBy",
  CHECKLIST: "checklist",
  MANAGE_INVOICES: "ManageInvoices",
  MEETING___PREFERENCE: "Meeting_Preference",
  IMAGE: "image",
  DEALSEARCHBAR: "dealsearchbar",
  BUDGET_APPROVAL: "budgetApproval",
  SUBMISSION_REVIEW: "submissionReview",
  SUBMISSION_APPROVAL: "submissionApproval",
  APPROVE_AND_REJECT: "approveAndReject",
  EXTERNAL_COMMITTEE: "externalCommittee",
  IMAGE_GALLERY: "imageGallery",
  ANNOUCMENT: "Annoucment",
  QUICK_LINKS: "quickLinks",
  IMAGE_CARD: "ImageCard",
  NEWS_PORTAL: "newsPortal",
  STATIC_PDF: "staticPDF",
  INVESTMENT_CASE: "investmentCase",
  MANUAL_UPDATE: "ManualUpdate",
  IR_REPORT: "irReport",
  QUARTERLY_KT_CODE_MAPPING: "ktCodeMapping",
  GST: "GST",
  TEARSHEET: "tearSheet",
  ESG: "ESGAdmin",
  ESGVIEW: "ESGView",
  ESGUserView: "ESGUserView",
  ESGAdmin: "ESGAdmin",
  MASTERMAPPINGDATA: "MasterMappingData",
  QUARTERLY_KT_CODE: "ktCode",
  ESGSubmissionSummary: "SubmissionSummary",
  ESGReport: "ESGReport",
  ESGScore: "ESGScore",
  ESGSubmission: "ESGSubmission",
  ESGApproval: "ESGApproval",
  ESGExistingQuestion: "ESGExistingQuestion",
  QuestionnaireScore: "QuestionnaireScore",
  IMPACT_DATA: "impactData",
  ESGRespondentActionPlan: "ESGActionPlan",
  MaturityMatrixPreviewTemplate: "MaturityMatrixPreview",
  ESG_MaturityMatrixPreviewLegend: "MaturityMatrixPreviewLegend",
  ESG_MaturityMatrixDashBoardLegend: "MaturityMatrixDashBoardLegend",
  ESGAdminCurrentPractice: "ESGCurrentPractices",
  ESGAdminBestPractice: "ESGBestPractices",
  ESGScoreSummary: "ESGScoreSummary",
  ESGMaturityMatrixLayout: "MaturityMatrix",
  PROPOSAL_TRACKER: "proposalTracker",
  COMMENT: "Comment",
  SUMMARIX: "SummarixUpload",
  RANGE_MEETING: "RangeMeeting",
};
// ESGScore
export const articleTypes = {
  APPROVE_AND_REJECT: "approveAndReject",
  SUBMISSION_REVIEW: "submissionReview",
  KPI_CALL_BOX: "KpiCallBox",
  KPI_SQL_BOX: "KpiSqlBox",
  DEALS_PIPE_LINE: "dealsPipeLine",
  PIPE_LINE_FILTER: "pipeLineFilter",
  REPORT_EDITOR: "reportEditor",
  EXCEL_EDITOR: "excelEditor",
  DEALSTATUSBAR: "dealstatusbar",
  ESG: "esg",
  ESGRESPONSE: "esgresponse",
  ESG_RESPONSE: "esgResponse",
  CONSENTREQUEST: "consentRequest",
  CUSTOMCARD: "customcard",
};

export const deviceTypes = {
  MD: "md",
  XS: "xs",
};

export const externalTypes = {
  GENERIC: "generic",
  BUTTON: "buttons",
  TEXT: "text",
  PIPELINE_DATA: "pipelineData",
  IMAGE_DATA: "imageData",
  IRC: "irc",
};

export const portfolioapproval = {
  PRIMARYAPPROVER: "primaryApprover",
  DATAAPPROVAL: "Data Approval",
  NOPENDINGDATA: "There are no pending files which are actionable.",
  APPROVE: "Approve",
  REJECT: "Reject",
  NEWDATA:
    "The new data displayed here will not be visible to the organisation until it has been approved",
  APP: "APP",
  REJ: "REJ",
  APPROVESTOREDPROCEDURE: "sp_PE_Approve_Data",
  REJECTSTOREDPROCEDURE: "sp_PE_Reject_Data",
  SOURCEID: "sourceId",
  FILTERVALUE: "filterValue",
  NODATATOAPPROVE: "No records available to be approved",
  NOTTHEDESIGNATEDAPPROVER: "The current user is not the designated approver",
  UNDEFINED: "undefined",
};
export const executeJSString = (
  JSString = "",
  dataSet = {},
  defaultReturn = true
) => {
  try {
    let cleanJSString = enhanceEvalString(JSString.toString(), dataSet);
    const fn = new Function(
      `${defaultReturn ? "return" : ""} ${cleanJSString}`
    );
    let finalValue = fn();
    return finalValue;
  } catch (error) {
    return false;
  }
};

const normalizeFlagValue = (value) => {
  if (typeof value === "boolean") return value;
  const text = `${value}`.trim().toLowerCase();
  if (["true", "1", "yes"].includes(text)) return true;
  if (["false", "0", "no", ""].includes(text)) return false;
  return text;
};

export const isDisabledWhen = (disabledWhen, dataSet) => {
  if (
    !disabledWhen ||
    typeof disabledWhen !== "object" ||
    !dataSet ||
    typeof dataSet !== "object"
  ) {
    return false;
  }
  return Object.entries(disabledWhen).some(
    ([field, expected]) =>
      field in dataSet &&
      normalizeFlagValue(dataSet[field]) === normalizeFlagValue(expected)
  );
};

export const getConfigValue = (config, keyName) => {
  if (!config || typeof config !== "object") {
    return undefined;
  }
  const target = `${keyName}`.toLowerCase();
  const match = Object.keys(config).find(
    (key) => key.toLowerCase() === target
  );
  return match === undefined ? undefined : config[match];
};

export const isTemplateHidden = (templateConfig, dataSet) =>
  isDisabledWhen(getConfigValue(templateConfig, "hideWhen"), dataSet);

export const isTemplateDisabled = (templateConfig, dataSet) =>
  isDisabledWhen(getConfigValue(templateConfig, "disabledWhen"), dataSet);

export const isCardLocked = (content, dataSet) =>
  isDisabledWhen(getConfigValue(content, "disabledWhen"), dataSet) ||
  executeJSString(content?.readOnlyTemplate, dataSet) === true;

export const getLockedMessage = (content) =>
  getConfigValue(content, "disabledMessage") || "";

export const LOAN_STAGE_LOCK_FLAG = "Final Offer Letter";

export const LOAN_STAGE_LOCK_MESSAGE =
  "Read-only: the loan has reached the Final Offer Letter stage.";

export const STAGE_LOCKED_LOAN_SECTIONS = [
  "Loan Terms",
  "Fees",
  "Cost Details",
];

export const isLoanStageLocked = (dataSet) =>
  isDisabledWhen({ [LOAN_STAGE_LOCK_FLAG]: true }, dataSet);

export const isLoanSectionLocked = (sectionTitle, dataSet) =>
  STAGE_LOCKED_LOAN_SECTIONS.includes(sectionTitle) &&
  isLoanStageLocked(dataSet);

export const getLoanSectionLockMessage = (sectionTitle) =>
  `${sectionTitle || "This section"} is read-only: the loan has reached the ` +
  `${LOAN_STAGE_LOCK_FLAG} stage.`;

/* A layout's templateSecurityUI carries the same { Read, Update, Full } shape
   as a page's pageSecurity, so it resolves through the same rules. */
export const PermissionChecker = (templateSecurity) =>
  hasAccess(templateSecurity, pageSecurityActions.UPDATE);

const matchCardByRef = (cards, ref) => {
  if (typeof ref === "number") {
    return cards[ref];
  }
  return cards.find(
    (card) =>
      card &&
      (card.id === ref || (card.header && card.header.title === ref))
  );
};

export const buildCardTabs = (cards = [], tabsConfig = null) => {
  if (Array.isArray(tabsConfig) && tabsConfig.length > 0) {
    const used = new Set();
    const groups = tabsConfig
      .map((tab) => {
        const groupCards = (tab.cards || [])
          .map((ref) => matchCardByRef(cards, ref))
          .filter(Boolean);
        groupCards.forEach((card) => used.add(card));
        return {
          label: tab.label || tab.title || "",
          cards: groupCards,
          pinned: !!tab.pinned,
        };
      })
      .filter((group) => group.cards.length > 0);

    const leftover = cards.filter((card) => !used.has(card));
    if (leftover.length > 0) {
      groups.push({ label: "More", cards: leftover });
    }
    return groups;
  }

  const order = [];
  const byLabel = {};
  cards.forEach((card) => {
    const label = (card && card.tab) || "Other";
    if (!byLabel[label]) {
      byLabel[label] = { label, cards: [] };
      order.push(byLabel[label]);
    }
    byLabel[label].cards.push(card);
  });
  return order;
};



export const fetchSalesTrackerSubmitFlag = async (loanId) => {
  try {
    const payload = [
      {
        id: "SalesTrackerSubmitFlag",
        spName: "DF.usp_GetSalesTrackerSubmitFlag",
        parameters: {
          LoanId: loanId,
        },
      },
    ];
    const response = await httpPost(`/SqlData/executeStoredProcedure`, payload);
    if (response && response[0]) {
      const isEnabledKey = response[0]?.IsEnabled || response[0]?.IsEnabed || response[0]?.value;
      return isEnabledKey && String(isEnabledKey).toLowerCase() === "yes";
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to fetch submit flag:", error);
  }
  return true;
};